import { render } from "./popularizeDetails.vue?vue&type=template&id=953518e0&scoped=true"
import script from "./popularizeDetails.vue?vue&type=script&lang=js"
export * from "./popularizeDetails.vue?vue&type=script&lang=js"

import "./popularizeDetails.vue?vue&type=style&index=0&id=953518e0&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-953518e0"]])

export default __exports__